if (!localStorage.getItem("appVersion")) {
  // console.log("not clear..." + localStorage.getItem("appVersion"));
  // console.log("not clear...appVersion:"+__APP_VERSION__);
  localStorage.setItem("appVersion", __APP_VERSION__);
}
if (Number(localStorage.getItem("appVersion")) !== __APP_VERSION__) {
  // console.log("clear..." + localStorage.getItem("appVersion"));
  // console.log("clear...appVersion:"+__APP_VERSION__);
  localStorage.clear();
  localStorage.setItem("appVersion", __APP_VERSION__);
  localStorage.setItem("tabCount", "1");
}

const consts = {
  serviceUrl: __SERVICE_URL__,
  mcServiceUrl: __MC_SERVICE_URL__,
  crsServiceUrl: __CRS_SERVICE_URL__,
  tmsServiceUrl: __TMS_SERVICE_URL__,
  tmsCdnServiceUrl: __TMS_CDN_SERVICE_URL__,
  poolExternalUrl: __POOL_EXTERNAL_URL__,
  environment: __ENVIRONMENT__,
  appVersion: __APP_VERSION__,
  dynamicPricing: __DYNAMIC_PRICING__,
};

export default consts;
